/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import React from "react";
export const GridFindContext = /*#__PURE__*/React.createContext(undefined);
GridFindContext.displayName = "GridFindContext";
export const useGridFindContext = () => {
  const context = React.useContext(GridFindContext);
  if (!context) {
    throw new Error('useGridFindContext must be used within a GridFindProvider');
  }
  return context;
};
//# sourceMappingURL=GridFindContext.js.map
